import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import NavigationSections from "./NavigationSections";
import { CHECKIN } from "../../../coaching-portal/tasks/task-constants";
import SvgIcon from "../../../../parts/SvgIcon";

const linksArrStats = [
  { route: "/metrics/readiness-rate", label: "Readiness Rate" },
  {
    route: "/metrics/accountability",
    label: "Accountability Tracker",
    key: "accountability",
  },
  { route: "/metrics/session-rpe", label: "Session RPE" },
  { route: "/metrics/bodyweight", label: "Bodyweight" },
  { route: "/metrics/step-count", label: "Step Count" },
  { route: "/metrics/sleep-time", label: "Sleep Time" },
  { route: "/metrics/hrv", label: "Heart Rate Variability (HRV)" },
  { route: "/metrics/body-measurements", label: "Body Measurements" },
  {
    route: "/metrics/progress-photos",
    label: "Progress Photos",
  },
  { route: "/metrics/body-composition", label: "Body Composition" },
  {
    route: "/metrics/check-in-summary",
    label: "Check-in Summary",
    key: "checkInSummary",
  },
];

const linksArrTraining = [
  { route: "/metrics/exercise-history", label: "Exercise History" },
  {
    route: "/metrics/block-review",
    label: "Block Review",
    key: "blockReview",
  },
  {
    route: "/metrics/annual-planner",
    label: "Annual Planner",
    key: "annualPlanner",
  },
  { route: "/metrics/video-list", label: "Video List" },
  { route: "/metrics/rpe-report", label: "RPE Table" },
  { route: "/metrics/personal-record", label: "Personal Records" },
  { route: "/metrics", label: "Strength Metrics", key: "strengthMetrics" },
];

const NavigationComponent = (
  { query, pathName = "", text = "Calendar", classNames = "" },
  { locals }
) => {
  const organizationCoach = query.organizationCoach || undefined;
  const [webViewState, setWebViewState] = useState();
  const { athlete, date = null, view = null, navFrom = null } = query;
  const { activeUser, organizationOwner } = locals;

  const urlStart = athlete ? "/athlete-portal" : "/dashboard";
  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  const athleteParam = athlete ? `&athlete=${athlete}` : "";
  const urlEnd = athleteParam + organizationCoachParam;
  const calendarUrlStart = athlete
    ? "/athlete-portal/calendar"
    : "/dashboard/calendar";
  const pathNameWithoutEndingSlash =
    pathName[pathName.length - 1] === "/"
      ? pathName.slice(0, pathName.length - 1)
      : pathName;

  useEffect(() => {
    setWebViewState(window.ReactNativeWebView);
  }, []);

  if (webViewState) return null;

  return (
    <aside role="secondary-navbar" className={`navigation-panel ${classNames}`}>
      {!!view && (
        <a
          href={`${calendarUrlStart}?view=day&date=${date}${urlEnd}`}
          className="link"
        >
          <SvgIcon src="/img/new-icons/back-button.svg" />
          <span>{text}</span>
        </a>
      )}
      {!!navFrom && (
        <a
          href={`/coaching-portal/${
            navFrom === "tasks" ? `${navFrom}?tab=${CHECKIN}` : navFrom
          }`}
          className="link"
        >
          <img src="/img/new-icons/back-button.svg" alt="arrow-back" />
          {navFrom}
        </a>
      )}

      <ul className="navigation-sections">
        <span>Body Stats</span>
        <NavigationSections
          linksArr={linksArrStats}
          activeUser={activeUser}
          organizationOwner={organizationOwner}
          pathNameWithoutEndingSlash={pathNameWithoutEndingSlash}
          urlStart={urlStart}
          view={view}
          date={date}
          urlEnd={urlEnd}
        />
        <span>Training</span>
        <NavigationSections
          linksArr={linksArrTraining}
          activeUser={activeUser}
          organizationOwner={organizationOwner}
          pathNameWithoutEndingSlash={pathNameWithoutEndingSlash}
          urlStart={urlStart}
          view={view}
          date={date}
          urlEnd={urlEnd}
        />
      </ul>
    </aside>
  );
};

NavigationComponent.contextTypes = { locals: PropTypes.object };

export default NavigationComponent;
